
















import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { Dictionary } from "../../domain/system";

@Component
export default class ViewMenu extends Mixins() {
  data() {
    return {
      geometryHandlers: [] as string[],
    };
  }
  geometryHandlers: string[];

  mounted(): void {
    this.$listenGeometryHandling(ns => this.geometryHandlers = (ns ? ns : []));
  }

  get geometryRegistrationDescription(): string {
    return this.geometryHandlers.join("、") + "を記憶します。";
  }

  get isGeometryRegisterable(): boolean {
    return (0 < this.geometryHandlers.length);
  }

  async registerGeometry(): Promise<void> {
    await this.$storeGeometry();
  }

  get isCloseEnable(): boolean {
    return this.$configuration.behavior.closer.isEnable && this.$store.getters.isManualCloseable !== false;
  }

  get isConfigurationButtonEnable(): boolean {
    return this.$configuration.behavior.configuration.isEnable;
  }

  launchConfigurationTool(): void {
    const service = DomainRegistry.localhost.getApplicationService();
    const parameter = new Dictionary<string, string>();
    parameter.set("action", "configuration");
    parameter.set("u", this.$store.getters.user.id);
    service.launch(null, parameter);
  }

  close(): void {
    this.postMessage("closeWindow");
  }

  private postMessage(command: string): void {
    const message = JSON.stringify({ key: command });
    window.postMessage(message, "*");
  }

  get buttonName(): string {
    return this.$configuration.system.window.restorer.label;
  }
}
